import { currentLanguage } from "../../../algorithms/storage";
import axios from "../../axiosConfig";

export const getAxisTableData = (token) => {
  return axios.get(`Task/GetAxisTable`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getEntityAxisTableData = (id,token) => {
  return axios.get(`Task/GetMemberChartStatusCountByCommunityId/${id}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};